module.exports = __webpack_public_path__ + "img/icon-barge.a2b029f2.png";